import { styled } from '@styles/stitches';

export const Form = styled('form', {
  display: 'flex',
  borderRadius: 5,
  height: 39,
  border: '1px solid $colors$primaryBorder',

  '&:hover': {
    border: '1px solid $colors$secondaryBorder',
  },

  input: {
    backgroundColor: 'transparent',
    width: '100%',
    border: 'none',
    color: '$primaryFill',
    padding: '$space$4',
    borderRadius: 0,

    '&::placeholder': {
      color: '$secondaryFill',
    },

    '&:focus': {
      outline: 0,
    },

    '@bp1': {
      fontSize: 14,
    },
  },

  button: {
    position: 'relative',
    top: -1,
    right: -1,
    flex: 'none',
    backgroundColor: '$primaryFill',
    color: '$primaryBackground',
    border: '1px solid $colors$primaryFill',
    cursor: 'pointer',
    width: 80,
    height: 39,
    borderRadius: 5,

    '&:focus': {
      outline: 0,
      backgroundColor: 'transparent',
      color: '$primaryFill',
    },

    '&:hover': {
      backgroundColor: 'transparent',
      color: '$primaryFill',
    },
  },

  '&bp1': {
    input: {
      fontSize: 14,
    },
  },
});

export const ButtonHolder = styled('div', {
  position: 'relative',
  top: -1,
  right: -1,
  flex: 'none',
  border: '1px solid $colors$primaryFill',
  cursor: 'pointer',
  width: 80,
  height: 39,
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
